"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _fabfitfunSharedGlobal = require("@bit/fabfitfun.shared.global.qty-controls");

var _fabfitfunSharedGlobal2 = _interopRequireDefault(_fabfitfunSharedGlobal);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _HeaderContext = require("../HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CartProduct = function CartProduct(props) {
  var id = props.id,
      campaignId = props.campaignId,
      callbacks = props.callbacks,
      cartLimit = props.cartLimit,
      name = props.name,
      variant = props.variant,
      descriptor = props.descriptor,
      quantity = props.quantity,
      inventoryState = props.inventoryState,
      imageUrl = props.imageUrl,
      isMobile = props.isMobile,
      salePrice = props.salePrice,
      cartAmount = props.cartAmount,
      expandProductDetails = props.expandProductDetails,
      shareUrl = props.shareUrl,
      legacyPostId = props.legacyPostId;
  var descriptorText = "(" + descriptor + ")";
  var rowContainerStyles = (0, _classnames2.default)({
    "d-flex": true,
    "flex-jsb": true,
    "w-100": isMobile,
    "w-85": !isMobile,
    "pad-4": true
  });
  var itemInfoContainerStyles = (0, _classnames2.default)({
    "w-60": isMobile,
    "fs-12": !isMobile,
    "w-85": !isMobile,
    "fs-9": isMobile
  });
  var titleStyles = (0, _classnames2.default)({
    "mar-0 ": true,
    "product-title": true,
    "ta-left": true,
    truncate: !isMobile,
    "w-70": !isMobile,
    "cur-pointer": true
  });
  var priceAndQtyContainerStyles = (0, _classnames2.default)({
    "fs-12": true,
    "ta-right": true,
    "ls-n": true,
    "pad-w-16": isMobile
  });

  var goToProduct = function goToProduct(setExpandedMenu) {
    expandProductDetails({
      id: id,
      name: name,
      shareUrl: shareUrl,
      legacyPostId: legacyPostId
    });
    setExpandedMenu(false);
  };

  return _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
    return _react2.default.createElement("div", {
      className: "d-flex"
    }, _react2.default.createElement("div", {
      className: "cart-image-container"
    }, _react2.default.createElement("img", {
      className: "cart-image",
      src: imageUrl,
      alt: name,
      onClick: function onClick() {
        return goToProduct(context.setExpandedMenu);
      }
    })), _react2.default.createElement("div", {
      className: rowContainerStyles
    }, _react2.default.createElement("div", {
      className: itemInfoContainerStyles
    }, _react2.default.createElement("p", {
      className: titleStyles,
      onClick: function onClick() {
        return goToProduct(context.setExpandedMenu);
      }
    }, name, " ", descriptor && _react2.default.createElement("span", null, descriptorText)), _react2.default.createElement("div", {
      className: "qty-container pad-w-8"
    }, _react2.default.createElement(_fabfitfunSharedGlobal2.default, {
      mini: true,
      qty: quantity,
      soldOut: inventoryState === "OUT",
      max: cartLimit,
      id: id,
      onRemove: function onRemove() {
        if (callbacks && callbacks.updateCart) {
          callbacks.updateCart({
            campaignId: campaignId,
            variantId: variant.id,
            qty: -1,
            variant: variant,
            salePrice: salePrice,
            id: id
          });
        }
      },
      onAdd: function onAdd() {
        if (callbacks && callbacks.updateCart) {
          callbacks.updateCart({
            campaignId: campaignId,
            variantId: variant.id,
            qty: 1,
            variant: variant,
            salePrice: salePrice,
            id: id
          });
        }
      }
    }))), _react2.default.createElement("div", {
      className: priceAndQtyContainerStyles
    }, _react2.default.createElement("p", {
      className: "mar-0 pad-h-4"
    }, "$", cartAmount), _react2.default.createElement("p", {
      className: "mar-0 t-ws-nowrap"
    }, "QTY: ", quantity))));
  });
};

exports.default = CartProduct;